// Zod-free constants split from ./segments so that consumers needing only these
// keys (e.g. the checkout UI extension bundle) don't pull ./segments and, through
// it, the zod-heavy ./checkout-tree module. ./segments re-exports these.

export const CHECKOUT_PROBABILITY_LINE_ITEM_PROPERTY_KEY =
  "_redo_intent_engine_checkout_probability";
